import React from 'react';

import PrimaryButton from '@/components/ui/Button/PrimaryButton';

type FooterLink = {
  label: string;
  href: string;
};

type FormFooterProps = {
  isSubmitting: boolean;
  submitLabel: string;
  buttonClassName?: string;
  buttonPaddingClassName?: string;
  buttonContainerClassName?: string;
  footerLink?: FooterLink;
  submitError?: string | null;
  children?: React.ReactNode;
  disabled?: boolean;
};

export function FormFooter({
  isSubmitting,
  submitLabel,
  buttonClassName,
  buttonPaddingClassName,
  buttonContainerClassName = 'flex items-center gap-4 pt-1',
  footerLink,
  submitError,
  children,
  disabled,
}: FormFooterProps) {
  return (
    <div>
      {submitError && (
        <div
          role="alert"
          aria-live="polite"
          className="mb-2 text-xs font-medium text-red-500"
        >
          {submitError}
        </div>
      )}
      <div className={buttonContainerClassName}>
        <PrimaryButton
          type="submit"
          data={{ title: isSubmitting ? 'Sending…' : submitLabel }}
          disabled={disabled ?? isSubmitting}
          className={buttonClassName}
          paddingClassName={buttonPaddingClassName}
        />
        {footerLink && (
          <a
            href={footerLink.href}
            className="text-royal-500 hover:text-royal-600 text-xs font-semibold underline"
          >
            {footerLink.label}
          </a>
        )}
        {children}
      </div>
    </div>
  );
}
